import React, { Fragment, useState } from "react";
import styles from "./MobileMenu.module.scss";
import classnames from "classnames";
import injectSectionElements from "../injectSectionElements";
import CloseIcon from "./CloseIcon";
import BurgerIcon from "./BurgerIcon";

const MobileMenu = (props) => {
  const [isOpen, setOpen] = useState(false);
  const {
    Elements,
    toggleClass,
    burgerClass,
    className,
    pages,
    languages,
    displayClass,
    menuItems,
    email,
    phone,
    emailIcon,
    phoneIcon,
    socialLinks,
    primaryButton,
    secondaryButton,
  } = props;

  const isLinksExist =
    email || phone || socialLinks || primaryButton || secondaryButton;
  return (
    <Fragment>
      <div
        className={classnames(styles.burger, toggleClass, displayClass)}
        onClick={() => {
          setOpen(true);
        }}
      >
        <BurgerIcon className={classnames(burgerClass)} />
      </div>
      <div
        className={classnames(displayClass, styles.menuContainer, {
          [className]: !!className,
          [styles.defaultMenuStyle]: !className,
          [styles["--open"]]: isOpen,
        })}
      >
        <div
          className={styles.closeButton}
          onClick={() => {
            setOpen(false);
          }}
        >
          <CloseIcon />
        </div>
        <div className={classnames(styles.menuLinksContainer)}>
          <Elements.NavMenu
            isMobile
            className={styles.navMenu}
            itemClass={styles.navItem}
            linkClass={styles.navLink}
            itemActive={styles.navItemActive}
            pages={pages}
            menuItems={menuItems}
          />
        </div>
        {isLinksExist && (
          <div className={styles.linksWrapper}>
            {email && (
              <div className={styles.styledFlex}>
                <Elements.Icon value={emailIcon} className={styles.icon} />
                <Elements.Button
                  type="Link"
                  value={email}
                  className={styles.linkButton}
                />
              </div>
            )}
            {phone && (
              <div className={styles.styledFlex}>
                <Elements.Icon value={phoneIcon} className={styles.icon} />
                <Elements.Button
                  type="Link"
                  value={phone}
                  className={styles.linkButton}
                />
              </div>
            )}
            {socialLinks && (
              <div className={styles.styledFlex}>
                <Elements.SocialLinks value={socialLinks} />
              </div>
            )}
            <div>
              {primaryButton && (
                <div className={styles.styledButton}>
                  <Elements.Button type="Primary" value={primaryButton} />
                </div>
              )}
              {secondaryButton && (
                <div className={styles.styledButton}>
                  <Elements.Button type="Secondary" value={secondaryButton} />
                </div>
              )}
            </div>
          </div>
        )}
        {languages.length > 1 && (
          <div className={styles.fixedBottom}>
            <span />
            <Elements.LanguageSwitcher
              dropTo="top"
              labelClass={styles.languageSwitcher}
              languages={languages}
            />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default injectSectionElements(MobileMenu);
